import React, { useState, useEffect, useRef } from 'react';
import { Link } from "react-router-dom";
import { Button, Badge } from "react-bootstrap";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import bgimage from '../../../../images/items/idly.png';
import Select from "react-select";
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import DatePicker from "react-multi-date-picker";
import { Row, Col, Tab, Nav, Dropdown } from "react-bootstrap";
import axios from 'axios';
import swal from "sweetalert2";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const baseURL = process.env.REACT_APP_API_BASE_URL;

const Daily_Orders = () => {

    // const baseURL = "http://192.168.3.110:1711/api";
    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);
    const user_id = parseInt(localStorage.getItem("user_id"), 10);

    const [slectedDate, setSelDate] = useState(new Date);

    const [datas, setData] = useState([]);
    const [hasFetched, setHasFetched] = useState(false);

    const formatDate = (date) => {
        const d = new Date(date); // ensures it's a Date object
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const fetchData = () => {
        const params = {
            assignment_date  : formatDate(slectedDate),
            branch_id: branch_id,
            // created_by: user_id,
        };
        axios.get(`${baseURL}/work-list`, { params: params })
            .then(res => {
                setData(res.data.data);
                setHasFetched(true);
            })
            .catch(error => {
                console.log('There was an error fetching the posts!', error);
                setHasFetched(true);
                setData([]);
            });
    }

    useEffect (() => {
        fetchData();
    }, []);

    const onInit = () => {
        //   console.log('lightGallery has been initialized');
    };

    const [key, setKey] = useState('work');
     
    const tableRef = useRef(null);
    
    useEffect(() => {
        if(hasFetched) {
            if (tableRef.current) {
                if (!$.fn.dataTable.isDataTable(tableRef.current)) {
                    $(tableRef.current).DataTable({
                        "responsive": true,
                        //   "aaSorting": [],
                        "ordering": false,
                        "language": {
                            "lengthMenu": "Show _MENU_",
                        },
                        "dom":
                            "<'row'" +
                            "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                            "<'col-sm-6 d-flex align-items-center justify-content-end mb-2'f>" +
                            ">" +
                            "<'table-responsive'tr>" +
                            "<'row'" +
                            "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                            "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                            ">"
                    });
                }
            }
        }
    }, [hasFetched]);

    const softRefresh = () => {
        setHasFetched(false);
        if ($.fn.dataTable.isDataTable(tableRef.current)) {
            $(tableRef.current).DataTable().destroy();
        }
        fetchData();
    }

    const [staffList, setStaffList] = useState([]);
    useEffect(() => {
        axios.get(`${baseURL}/dropdown/getstaff_by_role/5?branch_id=${branch_id}`)
            .then(response => {
                const items = Array.isArray(response.data?.data) ? response.data.data : [];
                setStaffList(items);
            })
            .catch(error => {
                console.error('There was an error fetching the posts!', error);
            });
    }, []);

    const StartedModel = (data) => {
        swal.fire({
            html: `
                      <div class="alert alert-success px-2 py-2" role="alert">
                          Are You Sure Want to change status ?
                          <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                      </div>
                      <p class="text-center"><b>Work Started</b></p>
                  `,
            showCancelButton: true,
            confirmButtonText: 'Yes! Completed',
            cancelButtonText: 'Cancel',
            reverseButtons: true,
            customClass: {
                title: 'fs-6',
                cancelButton: 'btn btn-sm btn-secondary',
                confirmButton: 'btn btn-sm btn-success',
                htmlContainer: 'text-left'
            },
            allowOutsideClick: false,
            allowEscapeKey: false,
        }).then((result) => {
            if (result.isConfirmed) {
                const payload = {
                    assignment_date: formatDate(slectedDate),
                    staff_id: data.staff_id,
                    item_id: data.item_id,
                    status: 4
                };
                axios.post(`${baseURL}/update-work-status`, payload)
                    .then(response => {
                        toast.success("Work Started Successfully!");
                        softRefresh();
                    })
                    .catch(error => {
                        console.error('Error assigning work:', error);
                        toast.error("Work Start Failed");
                        softRefresh();
                    });
            }
        });
    };

    const ConfirmationModal = (data) => {
        swal.fire({
            html: `
                      <div class="alert alert-success px-2 py-2" role="alert">
                          Are You Sure Want to change status ?
                          <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                      </div>
                      <p class="text-center"><b>Work Completed</b></p>
                  `,
            showCancelButton: true,
            confirmButtonText: 'Yes! Completed',
            cancelButtonText: 'Cancel',
            reverseButtons: true,
            customClass: {
                title: 'fs-6',
                cancelButton: 'btn btn-sm btn-secondary',
                confirmButton: 'btn btn-sm btn-success',
                htmlContainer: 'text-left'
            },
            allowOutsideClick: false,
            allowEscapeKey: false,
        }).then((result) => {
            if (result.isConfirmed) {
                const payload = {
                    assignment_date: formatDate(slectedDate),
                    staff_id: data.staff_id,
                    item_id: data.item_id,
                    status: 3
                };
                axios.post(`${baseURL}/update-work-status`, payload)
                    .then(response => {
                        toast.success("Work Completed Successfully!");
                        softRefresh();
                    })
                    .catch(error => {
                        console.error('Error assigning work:', error);
                        toast.error("Work Completion Failed");
                        softRefresh();
                    });
            }
        });
    };

    const ReworkModal = (data) => {
        swal.fire({
            html: `
                <div class="alert alert-danger px-2 py-2" role="alert">
                Are You Sure Want to change status ?
                <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                </div>
                <p class="text-center"><b>Rework</b></p>

                <div class="mt-4 text-start">
                <label class="fs-7" style="color: #000;">Reason<span style="color: red;">*</span></label>
                </div>
                <div style="display:block; margin-top: 4px;">
                <textarea id="reason" rows="2" placeholder="Enter Reason" style="width: 100%; border-radius: 5px; padding: 4px;"></textarea>
                </div>

                <div class="mt-3 text-start">
                <label class="fs-7" style="color: #000;">Select Staff<span style="color: red;">*</span></label>
                </div>
                <div style="display:block; margin-top: 4px;">
                <select id="staffSelect" style="width: 100%; border-radius: 5px; padding: 6px;">
                    <option value="">-- Select Staff --</option>
                    ${staffList.map(staff => `<option value="${staff.sno}">${staff.name}</option>`).join('')}
                </select>
                </div>
            `,
            showCancelButton: true,
            confirmButtonText: 'Yes! Rework',
            cancelButtonText: 'Cancel',
            reverseButtons: true,
            customClass: {
                title: 'fs-6',
                cancelButton: 'btn btn-sm btn-secondary',
                confirmButton: 'btn btn-sm btn-danger',
                htmlContainer: 'text-left'
            },
            allowOutsideClick: false,
            allowEscapeKey: false,

            preConfirm: () => {
                const reason = document.getElementById('reason')?.value.trim();
                const staffId = document.getElementById('staffSelect')?.value;

                if (!reason) {
                swal.showValidationMessage('Please enter a reason.');
                return false;
                }
                if (!staffId) {
                swal.showValidationMessage('Please select a staff.');
                return false;
                }

                return { reason, staffId };
            }
            }).then((result) => {
            if (result.isConfirmed) {
                const { reason, staffId } = result.value;

                const payload = {
                    assignment_date: formatDate(slectedDate),
                    staff_id: data.staff_id,
                    item_id: data.item_id,
                    status: 1,
                    rework_reason: reason,
                    rework_staff_id: staffId
                };
                axios.post(`${baseURL}/update-work-status`, payload)
                    .then(response => {
                        toast.success("Work updated Successfully!");
                        softRefresh();
                    })
                    .catch(error => {
                        console.error('Error assigning work:', error);
                        toast.error("Work Updation Failed");
                        softRefresh();
                    });
            }
            });
    };

    const Update = (data) => {
        swal.fire({
            html: `
                <div class="alert alert-info px-2 py-2" role="alert">
                    Are You Sure Want to Update This Item
                    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                </div>
                <p class="text-center"><b>Update</b></p>
                <div class="mt-4 text-start">
                    <label class="fs-7" style="color: #000;">Comments <span style="color: red;">*</span></label>
                </div>
                <div style="display:block; margin-top: 4px;">
                    <textarea id="update-reason" rows="2" placeholder="Enter Comments" style="width: 100%; border-radius: 5px; padding: 4px;"></textarea>
                </div>
                `,
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            reverseButtons: true,
            customClass: {
                title: 'fs-6',
                cancelButton: 'btn btn-sm btn-secondary',
                confirmButton: 'btn btn-sm btn-success',
                htmlContainer: 'text-left'
            },
            allowOutsideClick: false,
            allowEscapeKey: false,
            preConfirm: () => {
                const reason = document.getElementById('update-reason')?.value?.trim();
                if (!reason) {
                    swal.showValidationMessage('Please enter a comment.');
                    return false;
                }
                return reason;
            }
        }).then((result) => {
            if (result.isConfirmed) {
                const payload = {
                    assignment_date: formatDate(slectedDate),
                    staff_id: data.staff_id,
                    item_id: data.item_id,
                    status: 2,
                    update_reason: result.value
                };
                axios.post(`${baseURL}/update-work-status`, payload)
                    .then(response => {
                        toast.success("Work updated Successfully!");
                        softRefresh();
                    })
                    .catch(error => {
                        console.error('Error assigning work:', error);
                        toast.error("Work Updation Failed");
                        softRefresh();
                    });
            }
        });
    };
    
    const blinkingStyle = {
        animation: "blink 3s infinite",
    };

    return (
        <>
            <div className="d-flex align-items-center justify-content-between page-titles flex-wrap px-0 py-1 mx-0">
                <div className='mb-2'>
                    <div className="mb-0 px-0">
                        <h4 className='breadcrumb-header'>Manage Daily Orders</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active">Production Management</li>
                    </ol>
                </div>
                
            </div>

            <Col xl={12} className='mb-3'>
                <div className="custom-tab-1">
                    <Tab.Container activeKey={key} onSelect={(k) => setKey(k)}>
                        <Nav as="ul" className="nav-tabs">
                            <Nav.Item as="li" >
                                <Nav.Link as={Link} to="/manage-daily-orders">
                                    <i class="fa-solid fa-bowl-food px-2"></i>
                                    <label className="fs-6">Today's Item</label>
                                    {/* <Badge as="a" href="" bg=" badge-circle" className='badge-outline-danger ms-2 fw-bold fs-8'>25</Badge> */}
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item as="li" >
                                <Nav.Link eventKey="work" >
                                    <i class="fa-solid fa-utensils px-2"></i>
                                    <label className="fs-6">Work</label>
                                    {/* <Badge as="a" href="" bg=" badge-circle" className='badge-outline-danger ms-2 fw-bold fs-8'> 05</Badge> */}
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item as="li" >
                                <Nav.Link as={Link} to="/manage-daily-orders-rework">
                                    <i class="fa-solid fa-person-walking-arrow-loop-left px-2"></i>
                                    <label className="fs-6">Rework</label>
                                    {/* <Badge as="a" href="" bg=" badge-circle" className='badge-outline-danger ms-2 fw-bold fs-8'>05</Badge> */}
                                </Nav.Link>
                            </Nav.Item>
                        </Nav>

                        <Tab.Content className="pt-4">
                            
                            <Tab.Pane eventKey="work">

                                <Row className='mb-4'>
                                    <div className='col-lg-7'>
                                        <div className='row'>
                                            <div className="col-lg-6 mt-1">
                                                <label className="text-black font-w500 fs-7">Date</label>
                                                <div className='datepicker-wrapper d-flex'>
                                                    <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                                    <DatePicker
                                                        value={slectedDate}
                                                        format="DD-MM-YYYY"
                                                        placeholder='Select Date'
                                                        onChange={(date) => {
                                                            if (date) {
                                                                setSelDate(date.toDate()); // convert Moment to JS Date
                                                            } else {
                                                                setSelDate(null);
                                                            }
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-3 mt-4 pt-2">
                                                <Button className="me-2 btn-sm" variant="primary" onClick={softRefresh}>
                                                    <span className='font-w400'>Submit</span>
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                </Row>

                                <Row>
                                    <div className='col-lg-12 mb-2'>
                                        <table ref={tableRef} className="table align-top table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                                            <thead>
                                                <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                                                    <th className='min-w-100px'>Master</th>
                                                    <th className='min-w-100px'>Item</th>
                                                    <th className='min-w-80px'>Qty / Units</th>
                                                    <th className='min-w-80px text-center'>Production Time</th>
                                                    <th className='min-w-80px text-center'>Status</th>
                                                </tr>
                                            </thead>
                                            <tbody className="text-gray-600 fw-semibold fs-7">
                                                {datas.map((data, index) => (
                                                    <tr key={index}>
                                                        <td>
                                                            <label className='font-w500 fs-6 text-black'>{data.staff_name}</label>
                                                        </td>
                                                        <td>
                                                            <div className='d-flex align-items-center justify-content-start gap-2'>
                                                                <LightGallery
                                                                    onInit={onInit}
                                                                    speed={500}
                                                                    plugins={[lgThumbnail, lgZoom]}
                                                                >
                                                                    <div data-src={data.item_image || bgimage} className='border rounded px-1 py-0'>
                                                                        <img src={data.item_image || bgimage} alt={data.item_name} className='cursor-pointer w-50px h-50px' />
                                                                    </div>
                                                                </LightGallery>
                                                                <div className='d-flex flex-column align-items-start'>
                                                                    <label className='text-black font-w500 fs-7'>{data.item_name}</label>
                                                                    <label className='text-primary font-w500 fs-7'>{data.item_category} - {data.item_sub_category}</label>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <Badge bg="danger" className='py-1 px-2 fs-7'>{data.quantity}</Badge>
                                                        </td>
                                                        <td className='text-center'>
                                                            <label className='text-black font-w500 fs-7'>{data.production_time}</label>
                                                        </td>
                                                        <td className='text-center'>
                                                            {data.status === 0 && (
                                                                <Dropdown drop="">
                                                                    <Dropdown.Toggle as="a" className={`i-false cursor-pointer`}>  
                                                                        <label className='text-white py-1 px-2 rounded font-w600 fs-7 cursor-pointer' style={{backgroundColor: '#761586'}}>Work Assigned</label>
                                                                    </Dropdown.Toggle>
                                                                    <Dropdown.Menu >
                                                                        <Dropdown.Item href="#" className='text-black' onClick={() => StartedModel(data)}>Started</Dropdown.Item>
                                                                        <Dropdown.Item href="#" className='text-black'  onClick={() => Update(data)}>Update</Dropdown.Item>
                                                                        <Dropdown.Item href="#" className='text-black' onClick={() => ReworkModal(data)}>Rework</Dropdown.Item>
                                                                        <Dropdown.Item href="#" className='text-black' onClick={() => ConfirmationModal(data)}>Completed</Dropdown.Item>
                                                                    </Dropdown.Menu>
                                                                </Dropdown>
                                                            )}

                                                            {data.status === 1 && (
                                                                <Dropdown drop="">
                                                                    <Dropdown.Toggle as="a" className={`i-false cursor-pointer`}>  
                                                                        <Badge bg="danger" style={blinkingStyle} className='py-1 px-2 fs-7'>Rework</Badge>
                                                                    </Dropdown.Toggle>
                                                                    <Dropdown.Menu >
                                                                        <Dropdown.Item href="#" className='text-black' onClick={() => ConfirmationModal(data)}>Completed</Dropdown.Item>
                                                                    </Dropdown.Menu>
                                                                </Dropdown>
                                                            )}

                                                            {data.status === 2 && (
                                                                <Dropdown drop="">
                                                                    <Dropdown.Toggle as="a" className={`i-false cursor-pointer`}>  
                                                                        <Badge bg="info" className='py-1 px-2 fs-7'>Update</Badge>
                                                                    </Dropdown.Toggle>
                                                                    <Dropdown.Menu >
                                                                        <Dropdown.Item href="#" className='text-black' onClick={() => ConfirmationModal(data)}>Completed</Dropdown.Item>
                                                                    </Dropdown.Menu>
                                                                </Dropdown>
                                                            )}

                                                            {data.status === 3 && (
                                                                <label className='text-white py-1 px-2 rounded font-w600 fs-7' style={{backgroundColor: '#33b400ff'}}>Work Completed</label>
                                                            )}

                                                            {data.status === 4 && (
                                                                <Dropdown drop="">
                                                                    <Dropdown.Toggle as="a" className={`i-false cursor-pointer`}>  
                                                                        <Badge bg="warning" className='py-1 px-2 fs-7'>Work Started</Badge>
                                                                    </Dropdown.Toggle>
                                                                    <Dropdown.Menu >
                                                                        <Dropdown.Item href="#" className='text-black'  onClick={() => Update(data)}>Update</Dropdown.Item>
                                                                        <Dropdown.Item href="#" className='text-black' onClick={() => ReworkModal(data)}>Rework</Dropdown.Item>
                                                                        <Dropdown.Item href="#" className='text-black' onClick={() => ConfirmationModal(data)}>Completed</Dropdown.Item>
                                                                    </Dropdown.Menu>
                                                                </Dropdown>
                                                            )}
                                                        </td> 
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </Row>
                            </Tab.Pane>

                        </Tab.Content>
                    </Tab.Container>
                </div>
               
            </Col >

        </>
    )


}
export default Daily_Orders;